const shownItem = [
    { label: "10", value: 10 }, 
    { label: "30", value: 30 }, 
    { label: "50", value: 50 }, 
    { label: "100", value: 100 }
]

const otpStatusList = [
    { label: "Pending", value: "Pending" },
    { label: "Completed", value: "Completed" },
    { label: "Expired", value: "Expired" }
]

const userTypeList = [
    { label: "Member", value: "Customer" },
    { label: "Admin", value: "Admin" },
]

const transactionTypeList = [
    { label: 'WITHDRAW', value: 'WITHDRAW' },
    { label: 'DEPOSIT_CRM', value: 'DEPOSIT_CRM' },
    { label: 'TRANSFER_FROM_MT5', value: 'TRANSFER_FROM_MT5' },
    { label: 'DEPOSIT_MT5', value: 'DEPOSIT_MT5' },
    { label: 'ADJUST', value: 'ADJUST' },
    { label: 'Internal Transfer', value: 'TRANSFER' },
    { label: 'Lot Rebate Bonus', value: 'LOT_REBATE_BONUS' },
    { label: 'Contract Commission', value: 'CONTRACT_COMMISSION' },
    { label: 'Profit Sharing Bonus', value: 'PROFIT_SHARING_BONUS' },
    { label: 'Same Rank Bonus', value: 'SAME_RANK_BONUS' },
    { label: 'MT5 Profit', value: 'MT5_PROFIT' },
]

const configTypeList = [
    { label: 'Withdrawal No.', value: 'config_withdrawal_no' },
    { label: 'MT5 Current Login ID', value: 'config_mt5_current_login_id' },
    { label: 'Company Name', value: 'config_company_name' },
    { label: 'Network Fee', value: 'config_network_fee' },
    { label: 'Main TRX Account', value: 'config_main_trx_account' },
    { label: 'Company ID', value: 'config_company_id' },
    { label: 'Main Admin ID', value: 'config_main_admin_id' },
    { label: 'Main BSC Account', value: 'config_main_bsc_account' },
    { label: 'Main USDT Account', value: 'config_main_usdt_account' },
    { label: 'Main BSC USDT Account', value: 'config_main_bsc_usdt_account' },
    { label: 'Main USDT Wallet USDT Balance', value: 'config_main_usdt_wallet_usdt_balance' },
    { label: 'Main BSC USDT Wallet USDT Balance', value: 'config_main_bsc_usdt_wallet_usdt_balance' },
    { label: 'Main USDT Wallet TRX Balance', value: 'config_main_usdt_wallet_trx_balance' },
    { label: 'Ignore MT5 Login ID', value: 'config_ignore_mt5_login_ids' },
    { label: 'MT5 Dummy Account', value: 'config_mt5_dummy_accounts' },
    { label: 'MT5 Dummy Customer ID', value: 'config_dummy_customer_ids' },
    { label: 'TRX Transfer Amount', value: 'config_trx_transfer_amount' },
    { label: 'Minimum USDT Transfer Amount', value: 'config_minimum_usdt_transfer_amount' },
    { label: 'Stop Early Bird Flag', value: 'config_stop_rcfx_early_bird_flag' },
    { label: 'BNB Transfer Amount', value: 'config_bnb_transfer_amount' },
    { label: 'Stop Special Account Customer IDs', value: 'config_stop_rcfx_special_account_customer_ids' },
    { label: 'Block Withdrawal Customer IDs', value: 'config_block_withdrawal_customer_ids' },
    { label: '1000 USD Max Lot Per Month', value: 'config_max_lot_per_month' },
]

const languageList = [
    { name: 'English', code: 'en' },
	{ name: '中文 (简体)', code: 'zh_cn' },
	{ name: '中文 (繁體)', code: 'zh_tw' },
    { name: '日本語', code: 'ja' },
]

const rateTypeList = [
    { label: "Amount", value: "1" },
    { label: "Percentage", value: "2" },
]

const networkList = [
    { label: "TRC20", value: "TRON" },
    { label: "BEP20", value: "BSC" },
]

const customRankStatus = [
    { label: 'Active', value: "1" },
    { label: 'Inactive', value: "0" },
]

const withdrawNetworkList = [
    { label: "TRC20", value: "TRON" },
    { label: "BEP20", value: "BSC" },
]

const exportPageSize = 100;

const regexTwoDecimalPoint = /^[0-9]*(\.[0-9]{0,2})?$/;

const numField = ['config_stop_rcfx_early_bird_flag','config_withdrawal_no', 'config_mt5_current_login_id', 'config_network_fee', 'config_company_id', 'config_trx_transfer_amount', "config_max_lot_per_month", "config_minimum_usdt_transfer_amount", "config_bnb_transfer_amount", "config_main_usdt_wallet_usdt_balance", "config_main_bsc_usdt_wallet_usdt_balance", "config_main_usdt_wallet_trx_balance"];
const arrField = ['config_block_withdrawal_customer_ids','config_stop_rcfx_special_account_customer_ids','config_main_admin_id', "config_ignore_mt5_login_ids", "config_mt5_dummy_accounts", "config_dummy_customer_ids"];
const objField = ["config_main_trx_account", "config_main_usdt_account", "config_main_bsc_account", 'config_main_bsc_usdt_account', "config_trading_statistic", "config_coverage_regions"]


export { numField, arrField, objField, shownItem, otpStatusList, transactionTypeList, languageList, userTypeList, configTypeList, rateTypeList, exportPageSize, networkList, customRankStatus, withdrawNetworkList, regexTwoDecimalPoint };